import { ReactElement, useMemo } from 'react';
import { usePlanMeta, usePlanMutations } from '../state';
import { strategyMeta } from '../strategy';

import type { PlanningConfig } from 'modules/campaign/block/types';
import { useMembership } from 'services';
import { PlanResponse, PlanStrategyType } from '../types';
import { Action, ActionDropdown } from 'components';

export function StrategyButton(): ReactElement {
  const { plan_strategy, type, planning } = usePlanMeta();
  const planningConfig: PlanningConfig = useMembership().planning_config;

  const { available_strategies: available, lock } = planningConfig[type];
  const disabled = lock || !planning;

  const { runMutation, setPlan } = usePlanMutations();

  const actions: Action[] = useMemo(() => {
    async function setResolution(plan_strategy: PlanStrategyType) {
      const res = await runMutation<PlanResponse>(
        { method: 'POST', url: `plan/strategy/`, body: { plan_strategy } },
        {
          optimistic: (current) => ({ ...current, plan_strategy }),
          onSuccess: setPlan,
        },
      );
      res.unwrap();
    }

    return available.map((value) => {
      const active = value === plan_strategy;
      return {
        action: value,
        button: {
          active,
          disabled: active,
          children: strategyMeta[value].title,
          onClick: () => setResolution(value),
        },
      };
    });
  }, [available, plan_strategy, runMutation, setPlan]);

  return (
    <ActionDropdown
      actions={actions}
      variant="secondary"
      testId="strategy-actions"
      size="sm"
      title="Plan strategy"
      disabled={disabled}
    >
      {strategyMeta[plan_strategy].title}
    </ActionDropdown>
  );
}
